import React, { InputHTMLAttributes } from 'react';

import { LucidTheme, mqMin } from '@lucid/theme';

import Box from '../box/box';
import searchIcon from './search-icon.svg';

interface SearchBarProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ className, ...rest }) => {
  return (
    <Box
      css={(theme: LucidTheme) => ({
        alignItems: 'center',
        border: `1px solid ${theme.colors.coolGrey[40]}`,
        borderRadius: theme.radii.base,
        display: 'flex',
        padding: `12px ${theme.space.s16}px`,
        width: '100%',
        [mqMin.tablet]: {
          width: 'auto'
        },
      })}
      // eslint-disable-next-line react/jsx-sort-props
      className={className}
    >
      <img
        alt="search"
        css={(theme: LucidTheme) => ({ marginRight: theme.space.s16 })}
        src={searchIcon}
      />
      <input
        css={(theme: LucidTheme) => ({
          border: 'none',
          color: theme.colors.coolGrey[40],
          fontSize: theme.fontSizes[3],
          '&:focus': {
            outline: 'none'
          }
        })}
        {...rest}
      />
    </Box>
  );
};

export default SearchBar;
